import clientesLista from "@/modules/Clientes/pages/Index";
import novoCliente from "@/modules/Clientes/pages/Form";
import cobrancaCliente from "@/modules/Clientes/pages/Configuracao";
import contratoEditar from "@/modules/Clientes/pages/Contrato";

export default [
  {
    name: "clientesLista",
    path: "/clientes",
    component: clientesLista,
    meta: { title: "Clientes" },
  },
  {
    name: "clientesNovo",
    path: "/clientesNovo",
    component: novoCliente,
    meta: { title: "Clientes" },
  },
  {
    name: "clientesConfiguracao",
    path: "/clientesConfiguracao",
    component: cobrancaCliente,
    meta: { title: "Clientes" },
  },
  {
    name: "clientesContratoEditar",
    path: "/clientes/:id_empresa/contrato",
    component: contratoEditar,
    meta: { title: "Clientes" },
  },
];
